import React, { useState, useContext } from 'react';
import onClickOutside from "react-onclickoutside";
import styles from './styles';
import { CartContext } from 'contexts/CartContext';
import { withRouter } from 'react-router';

import { useHistory } from "react-router-dom";

const SubtotalMenu = ({toggleSubtotal, clearCart}) => {
    const history = useHistory();

    SubtotalMenu.handleClickOutside = () => toggleSubtotal();
    const { cart } = useContext(CartContext);
    const currentCartBalance = cart?.map(it => it.priceEUR).reduce((a, b) => a + b, 0) || 0;
    return (
        <styles.ContainerSubtotalMenu>
            <styles.ContainerSubtotalAmount>
                <div>Subtotal:</div>
                <div>{currentCartBalance} €</div>
            </styles.ContainerSubtotalAmount>
            <styles.ViewCartButton onClick={()=>{history.push('/shop/cart'); toggleSubtotal();}}>VIEW CART</styles.ViewCartButton>
            <styles.ClearCartButton onClick={()=>{clearCart(); toggleSubtotal();}}>Clear cart</styles.ClearCartButton>
        </styles.ContainerSubtotalMenu>
    );
};

const clickOutsideConfig = {
    handleClickOutside: () => SubtotalMenu.handleClickOutside
  };

export default withRouter(onClickOutside(SubtotalMenu, clickOutsideConfig));
